// filepath: packages/volto-wildcard-theme/src/components/PageLoaderView/PageLoaderView.tsx

import React from "react";
import VoltoView from "@plone/volto/components/theme/View/View";

export type PageLoaderViewProps = Record<string, unknown> & {
  label?: string;
};

const FORCE_SHOW_MS = 5 * 60 * 1000; // 5 minutes

export default function PageLoaderView(props: PageLoaderViewProps) {
  const label = props.label ?? "Loading…";

  return (
    <div className="pageLoaderViewShell">
      {/* HUGE debug badge so you can't miss it */}
      <div
        style={{
          position: "fixed",
          top: 8,
          left: 8,
          zIndex: 2147483647,
          padding: "8px 12px",
          background: "rgba(255,0,0,0.9)",
          color: "#fff",
          fontSize: 14,
          borderRadius: 8,
          pointerEvents: "none",
        }}
      >
        PageLoaderView OVERRIDE ACTIVE — forcing loader for 5 minutes
      </div>

      <VoltoView {...props} />

      <div className="pageLoaderOverlay" role="status" aria-live="polite">
        <div className="pageLoaderCard">
          <div className="pageLoaderSpinner" aria-hidden="true" />
          <div className="pageLoaderLabel">{label}</div>
          <div className="pageLoaderLabel" style={{ fontSize: 12, opacity: 0.8 }}>
            Forced visible for 5 minutes
          </div>
        </div>
      </div>

      {/* Auto-hide after 5 minutes (optional) */}
      <AutoHideAfterMs ms={FORCE_SHOW_MS} />
    </div>
  );
}

function AutoHideAfterMs({ ms }: { ms: number }) {
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    const t = window.setTimeout(() => setHidden(true), ms);
    return () => window.clearTimeout(t);
  }, [ms]);

  if (!hidden) return null;

  // When hidden, remove the overlay via DOM style (simple + reliable)
  const el = typeof document !== "undefined" ? document.querySelector(".pageLoaderOverlay") : null;
  if (el && el instanceof HTMLElement) el.style.display = "none";

  return null;
}
